import { actionCreators as profileActions } from '@map/state/profile';
import { actionCreators as userActions } from '@map/state/user';
import { Profile, User, windowExtended } from '@map/types';
import useAction from '@shared/hooks/useAction';
import mixpanel from '@shared/lib/mixpanel/mixpanel';
import axios from 'axios';
import { Dispatch } from 'redux';

type OauthCredentials = {
  code?: string;
  provider: string;
  locale: string;
};

type OauthResponse = {
  user: User;
  profile: Profile;
};
const oauth = (credentials: OauthCredentials) => (dispatch: Dispatch) =>
  axios
    .post<OauthResponse>(
      `/users/auth/${credentials.provider}/callback`,
      {
        ...credentials,
        invitation_token: windowExtended.invitation?.token,
        // this might be called outside of MAP context and miss this property
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        access_code: windowExtended.project?.access_code,
      },
      { withCredentials: true },
    )
    .then((result) => {
      const { user, profile } = result.data;
      if (result.status === 200) {
        mixpanel.identify(user.id);

        dispatch(userActions.userLoggedIn(user));

        if (profile.id) {
          dispatch(profileActions.profileFetched(profile));
        }

        return { success: true, user, profile };
      }

      return { success: false };
    });

const useOauthLogin = () => useAction(oauth);

export default useOauthLogin;
